import { BaseRepository } from '../../base';
import type { OrgModel } from './models/Org.model';

export class OrgRepository extends BaseRepository {
  constructor() {
    super('/org');
  }

  get() {
    return this.httpClient.get<OrgModel>('/').then(({ data }) => data);
  }
}
